import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import SectionContainer from '../SectionContainer';
import SectionTitle from '../SectionTitle';
import SectionText from '../SectionText';
import ClientToolsTable from './ClientToolsTable';
import { device } from '../../../../style/Sizes';
import { KaenguruText } from './AllSectionTexts';
import ScrollToTop from '../../../../hoc/ScrollToTop';
import Footer from '../../../Footer/Footer';

const Container = styled.div`
  width: 100%;
  height: auto;
  /* background: red; */
  text-align: center;
`;

const FirstSectionContainer = styled.div`
  position: relative;
  margin: 150px auto 72px auto;
  max-width: 1000px;
  padding-bottom: 0;
  background-color: #f5f5f5;
  /* background-color: #e6e9ea; */
  /* background-color: #C0C8CB; */
  /* background: gainsboro; */

  @media ${device.maxTablet} {
    padding-bottom: 32px;
  }
`;

const TitleContainer = styled.div`
  position: relative;
  float: left;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -47%);
  z-index: 2;
`;

const Title = styled.div`
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 79px;
  /* letter-spacing: -0.5px; */
`;

const SubTitle = styled.div`
  font-family: miller-headline, serif;
  font-weight: 700;
  font-style: italic;
  font-size: 19px;
  letter-spacing: 0.8px;
`;

const BadgeContainer = styled.div`
  margin-bottom: 72px;
`;

const BadgeWrapper = styled.a`
  padding: 0 15px;
`;

const StyledImg = styled.img`
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: 40px;
`;

// const Role = 'My Role';

const KaenguruContainer = () => {
  const [desktop, setDesktop] = useState();
  // const [clHeight, setClHeight] = useState();
  const [clWidth, setClWidth] = useState();

  const checkDesktop = () => {
    window.matchMedia('(min-width: 768px)').matches
      ? setDesktop(true)
      : setDesktop(false);
    // setClHeight(document.documentElement.clientHeight);
    setClWidth(document.documentElement.clientWidth);
  };

  useEffect(() => {
    checkDesktop();
  });

  useEffect(() => {
    window.addEventListener('resize', checkDesktop);
    return () => {
      window.removeEventListener('resize', checkDesktop);
    };
  });

  return (
    <ScrollToTop>
      <Container>
        <FirstSectionContainer clWidth={clWidth}>
          <TitleContainer>
            <Title>Känguru</Title>
            <SubTitle>Practicing math made easy</SubTitle>
          </TitleContainer>
          <SectionContainer
            noTransition
            containerMarginBottom={'100px'}
            src={require('../../../../assets/images/KaenguruTop.png')}
            alt="MockupTop"
            imgContainerHeight={'80vw'}
            imgContainerMaxHeight={'750px'}
            imgContainerMinHeight={''}
            imgHeight={'80%'}
            imgMarginTop={clWidth < 690 ? '55px' : '7%'}
          />
          <ClientToolsTable desktop={desktop} />
        </FirstSectionContainer>
        <SectionTitle
          sectionTitle={KaenguruText.AboutKaenguru}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={KaenguruText.AboutKaenguruText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={KaenguruText.TheChallenge}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={KaenguruText.TheChallengeText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={KaenguruText.MyRole}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={KaenguruText.MyRoleText}
          textMarginBottom={'68px'}
        />
        <SectionText
          sectionText="For more information, please visit:"
          textMarginBottom={'24px'}
        />
        <BadgeContainer>
          <BadgeWrapper
            href="https://apps.apple.com/de/app/mathe-mit-dem-k%C3%A4nguru/id414663462"
            title="Mathe mit dem Känguru"
          >
            <StyledImg
              src={require('../../../../assets/images/AppStoreBadge.png')}
            ></StyledImg>
          </BadgeWrapper>
          <BadgeWrapper
            href="https://play.google.com/store/apps/details?id=com.hanser.kaenguru"
            title="Mathe mit dem Känguru"
          >
            <StyledImg
              src={require('../../../../assets/images/GooglePlayBadge.png')}
            ></StyledImg>
          </BadgeWrapper>
        </BadgeContainer>
        {/* <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.DesignProcess}
          titleMarginBottom={'8px'}
          sectionSubTitle={KaenguruText.DesignProcessSub}
          subTitleMarginBottom={'default'}
          sectionText={KaenguruText.DesignProcessText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/DoubleDiamond.png')}
          alt="DesignProcess"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'70%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.Survey}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.SurveyText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/Survey.png')}
          alt="Survey"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.Interviews}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.InterviewText}
          textMarginBottom={'default'}
          // src={require('../../../../assets/images/TaskModel.png')}
          // alt="MockupTop"
          imgContainerHeight={'0'}
          // imgContainerMaxHeight={'700px'}
          // imgHeight={'80%'}
          // imgMarginTop={'20%'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.UserPersonas}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.UserPersonasText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/Personas.png')}
          alt="Personas"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.TaskModel}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.TaskModelText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/TaskModel.png')}
          alt="TaskModel"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'80%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.CustomerExperienceMap}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.CustomerExperienceMapText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/CustomerExperienceMap.png')}
          alt="CustomerExperienceMap"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'80%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.OpenCardSort}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.OpenCardSortText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/CardSort.png')}
          alt="CardSort"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.SiteMap}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.SiteMapText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/SiteMap.png')}
          alt="SiteMap"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'700px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.PaperPrototypes}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.PaperPrototypesText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/PaperPrototypes.png')}
          alt="MockupTop"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'1000px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.Wireframes}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.WireframesText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/Wireframes.png')}
          alt="Wireframes"
          imgContainerHeight={'80vw'}
          imgContainerMaxHeight={'1000px'}
          imgHeight={'90%'}
          imgMarginTop={'auto'}
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.UserFlow}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.UserFlowText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/UserFlow.png')}
          alt="UserFlow"
          imgContainerHeight={'90vw'}
          imgContainerMaxHeight={'900px'}
          imgHeight={'120%'}
          imgMarginTop={'-10%'}
          fullWidth
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.StyleTile}
          titleMarginBottom={'default'}
          sectionText={KaenguruText.StyleTileText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/StyleTile.png')}
          alt="StyleTile"
          imgContainerHeight={'90vw'}
          imgContainerMaxHeight={'900px'}
          imgHeight={'120%'}
          imgMarginTop={'auto'}
          fullWidth
        />
        <SectionContainer
          containerMarginBottom={'default'}
          sectionTitle={KaenguruText.VisualDesign}
          titleMarginBottom={'default'}
          // sectionText={KaenguruText.VisualDesignText}
          textMarginBottom={'default'}
          src={require('../../../../assets/images/VisualDesign.png')}
          alt="VisualDesign"
          imgContainerHeight={'190vw'}
          imgContainerMaxHeight={'2000px'}
          imgHeight={'120%'}
          imgMarginTop={'auto'}
          fullWidth
        /> */}
      </Container>
      <Footer />
    </ScrollToTop>
  );
};

export default KaenguruContainer;
